import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        console.log('')
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'nomor', 'createby', 'transferItem', 'tgl1', 'tgl2', 'outstand','typeTrf', 'DimCol','DimVal','nmcategory','headcategory','idStore','idStoreTo','purcOrderNo','vendorinfo'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                console.log('list str',str)
                const url = `/inventorytrf${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('data',data)
                const resp = await axios.post('/inventorytrf', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    saveTrfin(data) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('data',data)
                const resp = await axios.post('/inventorytrf/saveTrfin', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/inventorytrf/${obj.invTrfKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventorytrf/detail/${obj.invTrfKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj={}){
        return new Promise(async (resolve, reject) => {
            try {
                if(obj.invTrfKey){
                    const url = `/inventorytrf/print?key=${obj.invTrfKey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }
                
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'nomor', 'createby', 'transferItem', 'tgl1', 'tgl2','outstand','DimCol','DimVal','nmcategory','idStore','idStoreTo'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventorytrf/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'inventory_transfer_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // issuegroup() {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const { data } = await axios.get(`/inventoryout/issuedgroup`);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    store() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventoryout/store`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    
    posting(obj={}){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`/inventoryout/posting/${obj.invTrfKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
};